export default __webpack_public_path__ + "static/media/676.bcefc100.png";